<!--
 * @Description:市场营销-线索管理联系人，投放记录联系人  props edisabled 不可以编辑
   /marketing/clueTracking/view 线索跟踪详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-14 15:45:17
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" :dataSource="data" tableId="Zbu_clueTracking_view_tack" :needPage="false" ref="table">
  </cos-table>
  <cos-footer-button :hideOk="true"> </cos-footer-button>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import type { PropType } from 'vue'
import type { ClueManage } from '@/typings/api/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
defineProps({
  data: {
    type: Object as PropType<ClueManage['contact'][]>
  }
})
const columns = ref([
  {
    title: '来源系统',
    dataIndex: 'acceptor',
    dicData: dataConfig.acceptClueSystem
  },
  {
    title: '操作人',
    dataIndex: 'operatorName'
  },
  {
    title: '操作时间',
    dataIndex: 'operateTime'
  },
  {
    title: '操作类型',
    dataIndex: 'operateType'
  },
  {
    title: '操作内容',
    dataIndex: 'operateDesc'
  }
])
</script>
<script lang="ts">
export default { name: 'TrackingTabs' }
</script>
<style lang="scss" scoped></style>
